import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SignIn from 'components/forms/SignIn.jsx';
import SignUp from 'components/forms/SignUp.jsx';
import ForgotPassword from 'components/forms/ForgotPassword.jsx';
import VerifyUser from 'components/forms/VerifyUser.jsx';

/* Styles */
import styles from 'styles/login.module.scss';
import layoutStyles from 'styles/layout.module.scss';
import cn from 'classnames';

function LoginFlow({
  setUser,
  setAuthState,
  form
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  return (
    <>
    <div className={layoutStyles.header__blueBar} />
    <div className={layoutStyles.colorsBar}>
      <div className={cn(layoutStyles.colorsBar__red, layoutStyles.colorsBar__color)}></div>
      <div className={cn(layoutStyles.colorsBar__green, layoutStyles.colorsBar__color)}></div>
      <div className={cn(layoutStyles.colorsBar__orange, layoutStyles.colorsBar__color)}></div>
      <div className={cn(layoutStyles.colorsBar__blue, layoutStyles.colorsBar__color)}></div>
    </div>
    <div className={styles.loginFlow}>
      <div className={styles.loginFlow__formContainer}>
        {form === 'signIn' && (
          <SignIn
            setAuthState={setAuthState}
            setUser={setUser}
            setUsername={setUsername}
            setPassword={setPassword}
          />
        )}
        {form === 'signUp' && (
          <SignUp
            setAuthState={setAuthState}
            setUser={setUser}
            setUsername={setUsername}
            setPassword={setPassword}
          />
        )}
        {form === 'forgotPassword' && (
          <ForgotPassword
            setAuthState={setAuthState}
            setUser={setUser}
            setUsername={setUsername}
            username={username}
          />
        )}
        {form === 'verifyUser' && (
          <VerifyUser
            setAuthState={setAuthState}
            setUser={setUser}
            setUsername={setUsername}
            setPassword={setPassword}
            username={username}
            password={password}
          />
        )}
      </div>
    </div>
    </>
  );
}

LoginFlow.propTypes = {
  setAuthState: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
}

export default LoginFlow;